import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { PartnerFilter } from 'src/app/components/aftale/models';

@Component({
    selector: 'app-partner-list-filter',
    templateUrl: './partner-list-filter.component.html',
    styleUrls: ['./partner-list-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartnerListFilterComponent implements OnInit, OnDestroy {
  @Input() filter: PartnerFilter;

  @Output() filterChange: EventEmitter<boolean> = new EventEmitter();

  unsubscribe$ = new Subject<void>();

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.changeFilterParams();
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  changeFilterParams() {
    const queryParams: Params = {
      showInactive: this.filter.showInactive,
    };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      preserveFragment: true,
    });

    this.filterChange.emit(true);
  }

  hasFilters() {
    return this.filter.showInactive ?? false;
  }

  filterCount() {
    if (this.filter.showInactive) {
      return 1;
    } else {
      return 0;
    }
  }

  reset() {
    this.filter.showInactive = false;
    this.changeFilterParams();
  }

  isInactiveChecked() {
    return this.filter.showInactive ?? false;
  }

  onInactiveToggle() {
    this.filter.showInactive = !this.filter.showInactive;
    this.changeFilterParams();
  }
}
